import { AvailableToken } from '../components/TokenCard';

export const AVAILABLE_TOKENS: AvailableToken[] = [
  { 
    token: `<waitCount>`, 
    title: "Current Queue Length", 
    description: "Shows the number of people currently in the queue",
    example: "There are <waitCount> people ahead of you",
    calculation: "Direct value - no calculation needed"
  },
  { 
    token: `<currentWaitTime | minutesPerCall>`, 
    title: "Estimated Wait Time", 
    description: "Calculates: minutesPerCall × number of people in queue",
    example: "Your estimated wait time is <currentWaitTime | 5> minutes",
    calculation: "5 minutes per call × 3 people = 15 minutes"
  },
  { 
    token: `<currentMaxWait | minutesPerCall>`,
    title: "Maximum Wait Time", 
    description: "Calculates: minutesPerCall × number of people in queue",
    example: "The maximum wait time is <currentMaxWait | 8> minutes",
    calculation: "8 minutes per call × 3 people = 24 minutes"
  },
  { 
    token: `<currentAvgWait | minutesPerCall>`, 
    title: "Average Wait Time", 
    description: "Calculates: minutesPerCall × number of people in queue",
    example: "Average wait time is <currentAvgWait | 3> minutes",
    calculation: "3 minutes per call × 3 people = 9 minutes"
  },
];

// Substitute tokens with actual values (used for actual IVR playback, not preview display)
export const substituteTokensWithValues = (text: string): string => {
  let substituted = text;
  
  // Replace <waitCount> with sample value
  substituted = substituted.replace(/<waitCount>/g, '3');
  
  // Handle <currentWaitTime | number> patterns
  const currentWaitTimeMatches = substituted.match(/<currentWaitTime \| ([0-9]+)>/g);
  if (currentWaitTimeMatches) {
    currentWaitTimeMatches.forEach((match) => {
      const numberMatch = match.match(/([0-9]+)/);
      if (numberMatch) {
        substituted = substituted.replace(
          `<currentWaitTime | ${numberMatch[1]}>`,
          numberMatch[1]
        );
      }
    });
  }

  // Handle <currentMaxWait | number> patterns
  const currentMaxWaitMatches = substituted.match(/<currentMaxWait \| ([0-9]+)>/g);
  if (currentMaxWaitMatches) {
    currentMaxWaitMatches.forEach((match) => {
      const numberMatch = match.match(/([0-9]+)/);
      if (numberMatch) {
        substituted = substituted.replace(
          `<currentMaxWait | ${numberMatch[1]}>`,
          numberMatch[1]
        );
      }
    });
  }

  // Handle <currentAvgWait | number> patterns
  const currentAvgWaitMatches = substituted.match(/<currentAvgWait \| ([0-9]+)>/g);
  if (currentAvgWaitMatches) {
    currentAvgWaitMatches.forEach((match) => {
      const numberMatch = match.match(/([0-9]+)/);
      if (numberMatch) {
        substituted = substituted.replace(
          `<currentAvgWait | ${numberMatch[1]}>`,
          numberMatch[1]
        );
      }
    });
  }
  
  return substituted;
}; 